






































































import { Component, Vue } from 'vue-property-decorator'
import { HistoricoDeEtiqueta } from '@/models'

export const HISTORICO_DE_ETIQUETAS_KEY = 'HISTORICO_DE_ETIQUETAS'
const MAX_HISTORICO = 10

@Component
export default class DialogoDeHistoricoDeEtiquetas extends Vue {
	aberto = false
	historico: HistoricoDeEtiqueta[] = []
	reimprimindoId: string | null = null

	mostrar() {
		this.carregarHistorico()
		this.aberto = true
	}

	carregarHistorico() {
		try {
			this.historico = JSON.parse(localStorage.getItem(HISTORICO_DE_ETIQUETAS_KEY) || '[]')
		} catch {
			this.historico = []
		}
	}

	static salvar(item: HistoricoDeEtiqueta) {
		try {
			const historico: HistoricoDeEtiqueta[] = JSON.parse(localStorage.getItem(HISTORICO_DE_ETIQUETAS_KEY) || '[]')
			historico.unshift(item)
			if (historico.length > MAX_HISTORICO) {
				historico.length = MAX_HISTORICO
			}
			localStorage.setItem(HISTORICO_DE_ETIQUETAS_KEY, JSON.stringify(historico))
		} catch { /* silently fail */ }
	}

	reimprimir(item: HistoricoDeEtiqueta) {
		this.reimprimindoId = item.id
		this.$emit('reimprimir', item)
	}

	setCarregando(id: string | null) {
		this.reimprimindoId = id
	}

	limparHistorico() {
		localStorage.removeItem(HISTORICO_DE_ETIQUETAS_KEY)
		this.historico = []
	}

	formatarDataHora(iso: string): string {
		return new Date(iso).toLocaleString('pt-BR')
	}
}
